import Config from '../../config';
import AuthEndpoints from './authEndpoints';
import apiClient from '../apiClient';

export const postIdTokens = async ({
  idToken,
  refreshToken,
}: {
  idToken: string;
  refreshToken: string;
}) => {
  const { API_URL } = Config;
  const response = await apiClient.post(
    `${API_URL}${AuthEndpoints.setCookiesEndpoint}`,
    {
      idToken,
      refreshToken,
    },
    {
      withCredentials: true,
    },
  );
  return response.data;
};
